import { FC, useEffect, useRef, useState } from "react";
import { IonIcon } from "@ionic/react";
import { football } from "ionicons/icons";
import { useTranslation } from "react-i18next";
import { splashHaptic } from "./claimHaptics";
import { SaveMoment } from "./saveMoments";
import "./SaveSplash.css";

const SHOW_MS = 3600;
const OUT_MS = 350;

const HERO: Record<SaveMoment, JSX.Element> = {
    // The gold match ball the Goals row turned into, with a pip per goal
    hatTrick: (
        <>
            <div className="ss-ball">
                <IonIcon icon={football} />
            </div>
            <div className="ss-pips">
                <i />
                <i />
                <i />
            </div>
        </>
    ),
    // A ring closes around the 0 they kept
    cleanSheet: (
        <div className="ss-ring">
            <svg viewBox="0 0 128 128">
                <circle className="track" cx="64" cy="64" r="56" />
                <circle className="arc" cx="64" cy="64" r="56" />
            </svg>
            <b>0</b>
        </div>
    ),
};

/**
 * A full-screen moment earned on Save (SCORZA-110). One hero object moves;
 * a tap, or a few seconds, dismisses it.
 */
export const SaveSplash: FC<{
    moment: SaveMoment;
    score: string;
    onDone: () => void;
}> = ({ moment, score, onDone }) => {
    const { t } = useTranslation();
    const [leaving, setLeaving] = useState(false);
    const done = useRef(onDone);

    useEffect(() => {
        splashHaptic();
        const timer = setTimeout(() => setLeaving(true), SHOW_MS);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (!leaving) return;
        const timer = setTimeout(() => done.current(), OUT_MS);
        return () => clearTimeout(timer);
    }, [leaving]);

    return (
        <div
            className={`save-splash ${moment}${leaving ? " out" : ""}`}
            onClick={() => setLeaving(true)}
            data-testid="saveSplash"
            data-moment={moment}
        >
            <div className="ss-glow" />
            <div className="ss-hero">{HERO[moment]}</div>
            <div className="ss-title">
                {t(`editMatch.claimRack.${moment}Title`)}
            </div>
            <div className="ss-sub">
                {t(`editMatch.claimRack.${moment}Sub`)}
            </div>
            <div className="ss-meta">{score}</div>
            <div className="ss-tap">
                {t("editMatch.claimRack.tapToContinue")}
            </div>
        </div>
    );
};
